/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { EmailRecipientDto } from '@gh/builder-shared-data';
import {
  composeSetters,
  createArrayHelper,
  fieldStateByEntityConfig,
  fieldValidationSetter,
  fieldValidatorByEntityConfig,
  isEntityInvalid,
  setEntityField,
  TextTypes,
} from '@gh/common-shared';
import { WithEntityState } from '@gh/common-shared-data';
import { omit } from 'lodash';

export type EmailRecipient = WithEntityState<EmailRecipientDto>;

export const getEmailRecipientId = (recipient: EmailRecipient) => recipient.typeId;

export type EmailRecipientList = EmailRecipient[];

export const EMAIL_RECIPIENT_ENTITY_CONFIG = {
  recipients: { type: TextTypes.EmailList },
};

export const emailRecipientFieldState = fieldStateByEntityConfig(EMAIL_RECIPIENT_ENTITY_CONFIG);
export const emailRecipientValidateField = fieldValidatorByEntityConfig(EMAIL_RECIPIENT_ENTITY_CONFIG);

export const emailRecipientArr = createArrayHelper(getEmailRecipientId);
export const setEmailRecipientText = composeSetters(setEntityField, fieldValidationSetter(emailRecipientValidateField));

export const hasEmailRecipientsError = (recipients: EmailRecipient[]) => recipients.some(isEntityInvalid);

export const emailRecipientToDto = (recipient: EmailRecipient): EmailRecipientDto =>
  <EmailRecipientDto>omit(recipient, 'entityState');
